import { TextField } from '@statsbomb/kitbag-components';
import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';

export function SelectVideo({ id, onChange, value }) {
  const intl = useIntl();

  const handleChange = (event) => {
    onChange(event);
  };

  return (
    <TextField
      id={id}
      label={intl.formatMessage({ defaultMessage: 'URL', id: 'e6b39' })}
      onChange={handleChange}
      type="url"
      value={value}
      variant="secondary"
    />
  );
}

SelectVideo.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  value: PropTypes.string,
};

SelectVideo.defaultProps = {
  onChange: () => {},
  value: '',
};

export default { SelectVideo };
